import React from 'react';
import { useTempEdgeTranslator } from '../../../Hooks/useTranslation';
import DropdownList from '../../../components/common/Dropdown/DropdownList';
import { withCurrentOption } from '../../../utils/lookupOptions';

const PortalLookupDropdown = ({ label, name, options, idKey, textKey, currentId, currentText, testId, onChange }) => {
  const { tempedgeTranslator } = useTempEdgeTranslator();

  return (
    <div className="my-2">
      <label className="control-label">{tempedgeTranslator(label)}</label>
      <DropdownList
        name={name}
        value={{ [idKey]: currentId }}
        data={withCurrentOption(options, { [idKey]: currentId, [textKey]: currentText }, idKey)}
        valueField={idKey}
        textField={textKey}
        data-testid={testId}
        onChange={onChange}
      />
    </div>
  );
};

export default PortalLookupDropdown;
